import { BenefitChangeState } from '@/enums/benefitChangeState';
import { BenefitTabs } from '@/enums/benefitTabs.enum';
import { State, StateString } from '@witkac/kartamiejska-shared';

export const DEFAULT_LIST_COUNT = 10;

export const UNAUTHORIZED_MESSAGES = [
  "Access denied! You don't have permission for this action!",
  'Access denied! You need to be authorized to perform this action!',
  'Brak uprawnień.'
];

export const BenefitTabsFilters = {
  [BenefitTabs.ACTIVE]: { state: State[State.ACTIVE], upToDate: true, upcoming: false },
  [BenefitTabs.INACTIVE]: { state: State[State.INACTIVE], withInactive: true },
  [BenefitTabs.HIDDEN]: { state: State[State.HIDDEN] },
  [BenefitTabs.UPCOMING]: {
    state: State[State.ACTIVE],
    upcoming: true
  },
  [BenefitTabs.PAST]: {
    state: State[State.ACTIVE],
    past: true
  },
  [BenefitChangeState.EDITED]: {
    type: BenefitChangeState.EDITED,
    state: StateString.NOT_CONFIRMED
  },
  [BenefitChangeState.NEW]: {
    type: BenefitChangeState.NEW,
    state: StateString.NOT_CONFIRMED
  }
};

export const NOTIFICATION_TIMEOUT = 10000;
